import { render, staticRenderFns } from "./ShowcaseProjectCard.vue?vue&type=template&id=1eb94825&"
import script from "./ShowcaseProjectCard.vue?vue&type=script&lang=ts&"
export * from "./ShowcaseProjectCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports